export default __webpack_public_path__ + "static/media/game-win.2c1a2beb.png";